import { range } from 'lodash';
import { PassingLine } from '../PassingLine';
import type { PassFailThresholdProps } from '../../types';

/**
 * Renders pass/fail threshold label and the radial threshold marker line.
 */
export const PassFailThreshold: React.FC<PassFailThresholdProps> = ({
  circleRatio,
  numSeparatorsForPassingLine,
  passingLineHeight,
  passingLineMarginTop,
  passingLineTurn,
  passingThreshold,
  rotation,
}) => {
  return (
    <>
      <div
        className="pointer-events-none absolute"
        style={{
          height: '100%',
          position: 'absolute',
          transform: `rotate(${passingLineTurn}turn)`,
        }}
      >
        <div
          className="pointer-events-none relative"
          style={{
            height: `${passingLineHeight}px`,
            marginTop: passingLineMarginTop + -13,
            width: '2px',
            transform: `rotate(-${passingLineTurn}turn)`,
          }}
        >
          <div className="absolute left-full top-0 ml-2">
            <p className="font-display text-xl font-bold leading-none">
              <span className="block text-neutral-black">Passing</span>
              <span className="block text-neutral-gray-700">{passingThreshold}%</span>
            </p>
          </div>
        </div>
      </div>

      <PassingLine
        passingThreshold={passingThreshold}
        values={range(numSeparatorsForPassingLine + 1).map(
          (index) => (circleRatio / numSeparatorsForPassingLine) * index + rotation,
        )}
        style={{
          background: 'var(--color-neutral-black)',
          height: `${passingLineHeight}px`,
          marginTop: passingLineMarginTop,
          width: '2px',
        }}
      />
    </>
  );
};

PassFailThreshold.displayName = 'PassFailThreshold';

export default PassFailThreshold;